/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-28 14:34:32
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-16 11:45:49
 */
import { Col, Modal, Popover, Row, Tabs, notification } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { EditableList } from '../../../compnents/list/EditableList'
import { NavBar } from '../../../compnents/nav/NavBar'
import { Label } from '../../../compnents/widgets/Label'
import styles from '../MembersManagementPage.module.css'
import { TopUpRecordModalColumns, detailColumns, ExchangeRecordColumns } from '../columns'
import { useLocation } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { selectSettings } from '../../user/setting/settingSlice'
import {
  getMembersBaseInfo,
  getRechargeList,
  getMembersExchangeRecord,
  refundMemberPointExchangeRecord,
} from '../MembersManagementPageSlice'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { getMaskPhone } from '../../../models/phone'

export const MembersManagementDetailPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const settings = useSelector(selectSettings)

  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState('0')

  const [params, setParams] = useState({ current: 0, size: 10 })

  const [page, setPage] = useState({
    items: [],
    total: 10,
  })

  const [exchangeParams, setExchangeParams] = useState({ current: 0, size: 10 })

  const [exchangePage, setExchangePage] = useState({
    items: [],
    total: 0,
  })

  const [exchangePageLoading, setExchangePageLoading] = useState(false)

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [membersInfo, setMembersInfo] = useState<any>({})

  const [QXData, setQXData] = useState(true)
  
  // 获取查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    // location?.state?.isMenu  ? 会员管理 ：患者管理
    const itemCode = location?.state?.isMenu ? SJQXChecks.HZGLCKHZSJH : SJQXChecks.HZGLCKHZSJH
    dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
      .then(unwrapResult)
      .then((res: any) => {
        setQXData(res)
      })
  }
  
  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getRechargeList({
        ...params,
        memberId: location?.state?.membersId,
        type: Number(selectKey),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current && getPage()
  }, [params, selectKey])

  const getExchangePage = () => {
    if (selectKey !== '2') return
    setExchangePageLoading(true)
    dispatch(
      getMembersExchangeRecord({
        ...exchangeParams,
        memberId: location?.state?.membersId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setExchangePage({
          items: res.records || [],
          total: res.total || 0,
        })
      })
      .finally(() => setExchangePageLoading(false))
  }

  useEffect(() => {
    if (selectKey === '2') {
      exchangeParams.current && getExchangePage()
    }
  }, [exchangeParams, selectKey])

  useEffect(() => {
    setParams({ ...params, current: 1 })
    setExchangeParams({ current: 0, size: 10 })
    dispatch(getMembersBaseInfo({ memberId: location?.state?.membersId }))
      .then(unwrapResult)
      .then((res: any) => setMembersInfo(res))
  }, [location?.state?.membersId])
  return (
    <Col className={styles.detailWrap}>
      <NavBar
        where={['会员管理', '会员信息']}
        backtrace={{
          name: '会员管理',
          path: location?.state?.isMenu ? '/member' : '/statistics/outpatient',
          state: {
            state: '2',
          },
          routeName: location?.state?.isMenu ? '会员管理' : '患者管理',
        }}
      />
      <Col className={styles.contentWrap}>
        <div className={styles.contentTitle}>
          <Label label='会员基础信息' />
        </div>
        <Row style={{ fontWeight: 'bold', fontSize: '16px' }}>
          <Col span={7} style={{ margin: '0 10px' }}>
            手机号：{membersInfo?.memberPhone ? (!QXData ? getMaskPhone(membersInfo?.memberPhone) : membersInfo?.memberPhone) : '-'}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            姓名：{membersInfo?.memberName}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            生日：{membersInfo?.birthday}
          </Col>
        </Row>
        <Row
          style={{ fontWeight: 'bold', fontSize: '16px', marginTop: '10px' }}
        >
          <Col span={7} style={{ margin: '0 10px' }}>
            账户余额：{membersInfo?.balanceMoney?.toFixed(2)}
          </Col>
          <Popover
            title='备注：'
            content={
              <div style={{ width: '600px' }}>{membersInfo?.remarks}</div>
            }
          >
            <Col
              span={15}
              style={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                margin: '0 10px',
                cursor: 'pointer',
              }}
            >
              备注：{membersInfo?.remarks}
            </Col>
          </Popover>
        </Row>
        <Row style={{ margin: '10px 0 20px 0 ' }}>
          <Col span={7} style={{ margin: '0 10px' }}>
            实际充值金额：{membersInfo?.rechargeAmount?.toFixed(2)}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            充值次数：{membersInfo?.payNumber}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            实际消费金额：{membersInfo?.monetary?.toFixed(2)}
          </Col>
        </Row>
        <Tabs
          activeKey={selectKey}
          defaultActiveKey='0'
          onChange={(v: any) => {
            setSelectKey(v)
            if (v === '2' && exchangeParams.current === 0) {
              setExchangeParams({ current: 1, size: 10 })
            }
          }}
        >
          <Tabs.TabPane tab='充值明细' key='0'>
            <EditableList
              className={styles.patientLable}
              loading={pageLoading}
              style={{ overflow: 'hidden' }}
              scroll={{ x: '28rem', y: '25rem' }}
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              onChangePage={(current, size) =>
                setParams({ ...params, current, size: size || 10 })
              }
              columns={TopUpRecordModalColumns(
                params.size * (params.current - 1),
                1
              )}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='消费明细' key='1'>
            <EditableList
              className={styles.patientLable}
              loading={pageLoading}
              scroll={{ x: '28rem', y: '25rem' }}
              style={{ overflow: 'hidden' }}
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              onChangePage={(current, size) =>
                setParams({ ...params, current, size: size || 10 })
              }
              columns={detailColumns(params.size * (params.current - 1))}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='会员明细' key='2'>
            <EditableList
              className={styles.patientLable}
              loading={exchangePageLoading}
              scroll={{ x: '28rem', y: '25rem' }}
              style={{ overflow: 'hidden' }}
              page={{
                items: exchangePage.items,
                current: exchangeParams.current,
                size: exchangeParams.size,
                total: exchangePage.total,
              }}
              onChangePage={(current, size) =>
                setExchangeParams({ current, size: size || 10 })
              }
              columns={ExchangeRecordColumns(
                Math.max(0, exchangeParams.size * (exchangeParams.current - 1)),
                (text, record) => {
                  if (text === 'refund') {
                    Modal.confirm({
                      title: '确认退货',
                      content: '退货后商品会自动退回到库存，积分会自动返回到用户账上',
                      maskClosable: false,
                      okText: '确定',
                      cancelText: '取消',
                      onOk: () => {
                        dispatch(
                          refundMemberPointExchangeRecord({ id: record?.id })
                        )
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({ message: '退货成功' })
                            getExchangePage()
                          })
                          .catch(() => {
                            notification.error({ message: '退货失败' })
                          })
                      },
                    })
                  }
                },
                settings
              )}
            />
          </Tabs.TabPane>
        </Tabs>
      </Col>
    </Col>
  )
}
